export default __webpack_public_path__ + "static/media/coin.0f1681b0.png";